import React from 'react';
import { useSelector } from 'react-redux';

import { Filters } from '../../components/Filters';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { getFiltersList } from './helpers';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../../utils/category';

export const FiltersContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  const filters = getFiltersList(dealType);

  return <Filters items={filters} dealType={dealType} offerType={offerType} />;
};
